<template>
  <a-modal
    width="600px"
    title="请进行配方分类设置"
    :visible="visible"
    @ok="ok"
    @cancel="cancel"
    :closable="false"
    :maskClosable="false"
  >
    <div>
      <span>配方分类：</span>
      <a-radio-group v-model="typeClassify">
        <a-radio :value="1">自产配方</a-radio>
        <a-radio :value="2">代工配方</a-radio>
        <a-radio :value="3">定制配方</a-radio>
      </a-radio-group>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="ok">确定</a-button>
    </div>
  </a-modal>
</template>

<script>
import { nhfMixins } from "../../untils";
export default {
  components: {},
  props: [],
  mixins: [nhfMixins],
  data() {
    return {
      typeClassify: 1
    }
  },
  watch: {},
  computed: {
    visible(){
      return this.setClassVisible
    },
  },
  created() {},
  mounted() {},
  methods: {
    async ok(){
      if(!this.typeClassify && this.typeClassify !== 0){
        this.$message.warning('请选择配方分类')
        return
      }
      // updateFormulaTypeClassify
      await this.fetchPost({
        actions:this.updateFormulaTypeClassify,
        data:{
          id: this.$route.query.id,
          typeClassify: this.typeClassify
        }
      })
      this.$emit('refreshDetail')
      this.setState({setClassVisible: false})
    },
    cancel(){
      this.setState({setClassVisible: false})
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>